import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * Der Feed-Durchschnittsscore fuer den Erfolgsmoment-Leerzustand
 * (Entwurfs-Schalter `leerzustand`).
 *
 * Liest den juengsten `feed_health_snapshots`-Befund des Feeds — dieselbe
 * Quelle, aus der der Feed-Check seine Kopfzahl bezieht. Die Zahl beantwortet
 * "wie steht der FEED", nicht "was hat ein Lauf gebracht"; einen Lauf-Bezug
 * behauptet der Leerzustand nirgends (Einordnung in
 * `src/test/runScope.ts` -> NOT_A_RUN_SURFACE).
 *
 * EIGENER HOOK statt useQuery direkt im Reviewer: `WorkbenchReviewer.test.tsx`
 * stellt BEWUSST keinen QueryClient und mockt stattdessen die Daten-Hooks —
 * eine Query im Bauteil selbst risse alle 118 Tests der Datei. Hier ist sie
 * mockbar wie `useWorkbenchStatusCounts`.
 *
 * `enabled` gattert auf Schalter UND anzeigenden Zustand: auf /workbench
 * (kein Provider, STANDARD `schlicht`) entsteht KEIN Request. Fehler und
 * fehlende Befunde liefern null — die Zeile faellt im Leerzustand weg, statt
 * eine erfundene Zahl zu zeigen.
 */
export function useErfolgsmomentAvgScore(
  feedId: string | null | undefined,
  enabled: boolean,
): number | null {
  const { data } = useQuery({
    queryKey: ['werkbank-erfolgsmoment-avg', feedId],
    enabled: enabled && !!feedId,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const { data: rows, error } = await supabase
        .from('feed_health_snapshots')
        .select('avg_score')
        .eq('feed_id', feedId!)
        .order('created_at', { ascending: false })
        .limit(1);
      if (error) return null;
      return rows?.[0]?.avg_score ?? null;
    },
  });
  return data ?? null;
}
